let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i2kjI")).then(() => parcelRequire('cnE20'));